export default "/images/register-step1.png?780077d980f433ac69c2542f60d983ec";